import { create } from 'zustand';
import Instance from '../Utils/Axios';

const useUserStore = create((set, get) => ({
  userProfile: null,
  loading: false,
  error: null,
  fetchPromise: null,

  fetchProfile: async (force = false) => {
    if (get().fetchPromise) {
      return get().fetchPromise;
    }

    if (get().userProfile && !force && !get().error) {
      return Promise.resolve(get().userProfile);
    }

    const promise = (async () => {
      set({ loading: true, error: null });
      try {
        const response = await Instance.post("/user/profile", {});
        const profile = response.data.userProfile || null;
        
        set({ 
          userProfile: profile, 
          loading: false, 
          fetchPromise: null 
        });

        // Handle unauthorized
        if (response.data.resCode == 400) {
          localStorage.removeItem("tokenId");
        }

        return response.data;
      } catch (err) {
        let errorMsg = err.response?.data?.resMessage || err.response?.data?.message;
        if (errorMsg && typeof errorMsg === 'object') {
          errorMsg = errorMsg.resMessage || errorMsg.message || JSON.stringify(errorMsg);
        }
        set({ 
          error: errorMsg, 
          loading: false, 
          fetchPromise: null 
        });
        throw err;
      }
    })();

    set({ fetchPromise: promise });
    return promise;
  },

  setUserProfile: (profile) => set({ userProfile: profile }),
  clearProfile: () => set({ userProfile: null, error: null, fetchPromise: null }),
}));

export default useUserStore;
